var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxDollar = function Svg12PxDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25v13.5M11.988 5.63c-.648-1.535-1.946-1.882-2.926-1.882-.911 0-3.306.485-3.084 2.783.155 1.613 1.676 2.214 3.005 2.451s3.258.743 3.306 2.689c.039 1.645-1.439 2.768-3.227 2.768-1.707 0-2.895-.664-3.352-2.166"
  }))));
};
export default Svg12PxDollar;